import React, { Component } from "react";
import { Notification, TextInputSkeleton } from "carbon-components-react";
import Modal from "@acadia-ui/modal";
import "carbon-components/scss/components/notification/_inline-notification.scss";
import { onStateChange } from "events";
import ErrorHelpers from "../../Components/FormBuilder/ErrorHelpers";
import FormBuilderV2 from "../../Components/FormBuilder/FormBuilderV2";
import { putCreatives } from "../../Flux/Actions/CreativesActions";
import UpdateStateHelper from "../../Components/FormBuilder/UpdateStateHelper";
import ModalHelpers from "../Modals/ModalHelpers";
import CreativesDataStore from "../../Flux/Stores/CreativesDataStore";
import MasterCampaignsStore from "../../Flux/Stores/MasterCampaignsStore";
import BookFiltersStore from "../../Flux/Stores/BookFiltersStore";
import "./modal.scss";
import moment from "moment";
import Loading from "../../Components/LoadingSpinner";
import Button from "@acadia-ui/button";
import { showToast, TOAST_TYPE, ToastNotification } from "@acadia-ui/toast";

const initialState = {
	formData: {},
	postData: {},
	errors: {},
	isFormDataValid: false
};

const formEl = "create_creative";

class CreateCreative extends Component {
	constructor(props) {
		super(props);
		this.state = {
			metaData: {
				StartDate: this.props.metaData.StartDate ? moment(this.props.metaData.StartDate).format("YYYY/MM/DD") : null,
				EndDate: this.props.metaData.EndDate ? moment(this.props.metaData.EndDate).format("YYYY/MM/DD") : null
			},
			loading: false,
			...initialState,
			isShow: false
		};
	}

	componentDidMount() {
		this.props.newCreative(this);
		CreativesDataStore.on("creatives_fail", this.handleErrors);
		CreativesDataStore.on("creative__errors__reset", this.handleReset);
		CreativesDataStore.on("creatives_success", this.handleSuccess);
		CreativesDataStore.on("create_and_add_creatives_success", this.handleCreateAnotherSuccess);
		this.setInitialFormData();
	}

	componentWillUnmount() {
		this.props.newCreative(undefined);
		CreativesDataStore.removeListener("creatives_fail", this.handleErrors);
		CreativesDataStore.removeListener("creative__errors__reset", this.handleReset);
		CreativesDataStore.removeListener("creatives_success", this.handleSuccess);
		CreativesDataStore.removeListener("create_and_add_creatives_success", this.handleCreateAnotherSuccess);
	}

	handleSuccess = () => {
		this.setState({ loading: false }, () => {
			this.triggerOpenClose();
			this.props.updateCounts("Creative");
		});
		showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.SUCCESS} message="Creative added successfully." timed={5000} />);
	};

	handleErrors = () => {
		this.setState({ loading: false }, () => {
			const errors = CreativesDataStore.getErrors();
			if (Object.keys(errors).length > 0) {
				const creativeErrors = errors;
				const type = "create creative";
				this.setState({ errors: creativeErrors, showErrors: true }, () => {
					// console.log(this.state);
					ErrorHelpers.displayErrors(formEl, this.state.errors, type);
					showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.ERROR} message="Creative could not be added." />);
				});
			}
		});
	};

	/* Needed for all Modals */
	triggerOpenClose = (event) => {
		if (this.state.loading === false) {
			ModalHelpers.openClose(event, this.updateModalState, this.state, initialState, () => {
				if (!this.state.open) {
					UpdateStateHelper.matchParentValues(this, this.props.config);
					this.isValidFormData();
				}
				ErrorHelpers.resetErrors(formEl);
			});
		}
	};

	updateModalState = () => {
		this.setState({ open: !this.state.open, ...initialState });
	};
	/* END */

	handleReset = () => {
		ErrorHelpers.resetErrors(formEl);
	};

	setInitialFormData = () => {
		this.handleReset();
		const configObjs = Object.entries(this.props.config);
		for (const dataBucket of configObjs) {
			if (dataBucket[0] != "ChildData") {
				for (const field of dataBucket[1]) {
					if (field.Name && field?.FieldType != "Hidden") {
						this.state.formData[field.Name] = { disabled: false, parentName: null, value: "" };
					}
				}
			}
		}
		this.isValidFormData();
	};

	isValidFormData = () => {
		const { formData } = this.state;
		let isValid = true;
		for (const key in formData) {
			if (Object.hasOwn(formData, key)) {
				const { value } = formData[key];
				const isDisabled = formData[key].disabled;
				if ((value == "" || value == null || value == undefined || value == "0.00") && !isDisabled) {
					isValid = false;
				}
			}
		}

		this.setState({ isFormDataValid: isValid });
	};

	updateState = (dataConfig, name, value, id, dataType, calc, disabled) => {
		// The reference to THIS is used to update the proper state
		if (this.state.loading === false) {
			UpdateStateHelper.update(dataConfig, name, value, id, dataType, true, formEl, this, disabled, this.props.config, false, this.isValidFormData);
		}
	};

	sortTaxonomyData = (taxonomyData) => {
		const taxDataWithPositions = taxonomyData;
		taxDataWithPositions.forEach((taxonomyField) => {
			if (this.props.config.TaxonomyData) {
				this.props.config.TaxonomyData.forEach((taxFieldConfig) => {
					if (taxFieldConfig.ID === taxonomyField.dataKeyID) {
						taxonomyField.Position = taxFieldConfig.Position;
					}
				});
			}
		});
		taxDataWithPositions.sort((a, b) => {
			if (a.Position < b.Position) {
				return -1;
			}
			if (a.Position > b.Position) {
				return 1;
			}
			return 0;
		});
		taxDataWithPositions.forEach((taxonomyField) => {
			delete taxonomyField.Position;
		});
		return taxDataWithPositions;
	};

	/* This should be a helper object that formats POST JSON for the PUT Actions */
	formDataObjForPost = (newRowObj) => {
		if (Object.keys(newRowObj).length > 0) {
			const postData = { ...this.state.postData };
			let strippedTaxonomyPostData = [];

			/* Removes the Key from the Taxonomy Data Array : Theja's Post does not like it */
			for (const i in postData.TaxonomyData) {
				strippedTaxonomyPostData.push(postData.TaxonomyData[i]);
			}
			strippedTaxonomyPostData = this.sortTaxonomyData(strippedTaxonomyPostData);
			const strippedMetadataPostData = [];
			for (const i in postData.MetaData) {
				strippedMetadataPostData.push(postData.MetaData[i]);
			}
			postData.MetaData = strippedMetadataPostData;

			/* postData is a copy of the state, so we just overwrite the innards with our new array */
			postData.TaxonomyData = strippedTaxonomyPostData;
			const filters = BookFiltersStore.getChoicesState();
			const campaignUniqueID = MasterCampaignsStore.getParentCampaignUniqueID();
			if (postData.CreativeData) {
				postData.CreativeData.MasterCampaignID = this.props.metaData.MasterCampaignID;
				postData.CreativeData.CampaignID = this.props.metaData.CampaignUniqueIDCode;
				// postData.CreativeData.UniqueID = this.props.metaData.UniqueID;
			} else if (!postData.CreativeData) {
				postData.CreativeData = {};
				postData.CreativeData.MasterCampaignID = this.props.metaData.MasterCampaignID;
				postData.CreativeData.CampaignID = this.props.metaData.CampaignUniqueIDCode;
			}
			// const MasterUniqueCodeID = MasterCampaignsStore.getMasterUniqueID();
			/* Config will hold the ID's of the filters */
			const PlatformID = filters.platform.value;
			const AuditLevelID = this.props.auditLevelID;
			// const auditlevelID = filters.auditlevel.value;
			const contextValues = BookFiltersStore.getContextValues();
			const formSubmissionObj = {
				MasterAgencyDivisionName: contextValues?.agency?.name,
				MasterBusinessUnitName: contextValues?.client?.name,
				MasterCountryCode: contextValues?.country?.name,
				ContextID: contextValues.contextId,
				PlatformID,
				AuditLevelID,
				MasterRegionCode: contextValues?.region?.name,
				CampaignUniqueIDCode: campaignUniqueID,
				...postData
			};
			// console.log(formSubmissionObj);
			return formSubmissionObj;
		}
		this.setState({ errors: { Errors: ["Please fill in all form fields."] }, showErrors: true }, () => {
			ErrorHelpers.displayErrors(formEl, this.state.errors);
		});
	};

	handleSubmit = (e) => {
		if (this.state.loading === false) {
			this.setState({ loading: true }, () => {
				e.preventDefault();
				/* Server Side Validation */
				this.sendPostObject(this.state.formData, true);
			});
		}
	};

	handleCreateAnother = (e) => {
		if (this.state.loading === false) {
			this.setState({ loading: true }, () => {
				e.preventDefault();
				this.sendPostObject(this.state.formData, false);
			});
		}
	};

	handleCreateAnotherSuccess = () => {
		this.setState({ loading: false }, () => {
			this.handleReset();
			this.props.updateCounts("Creative");
		});

		this.setState({ isShow: true }, () => {
			setTimeout(() => {
				this.setState({ isShow: false });
			}, 3000);
		});

		if (this.state.isShow === true) {
			const element = document.getElementsByClassName("showMessage");
			if (element.length !== 0) {
				if (element[0] !== undefined) {
					element[0].scrollIntoView();
				}
			}
		}
	};

	sendPostObject = (newRowObj, closeModal) => {
		this.postObject = this.formDataObjForPost(newRowObj);
		if (this.postObject) {
			if (this.postObject.CreativeData) {
				this.postObject.CreativeData.UniqueID = 1;
			} else {
				this.postObject.CreativeData = {
					UniqueID: 1
				};
			}
			const arrayPostObject = [this.postObject];
			const updatedData = putCreatives(arrayPostObject, closeModal);
		}
		if (this.postObject === undefined) {
			this.setState({ loading: false });
		}
	};

	render() {
		/* Temp Test Function -- Loads a skeleton if nothing there yet */
		const isDisabled = this.state.loading ? "disabledModal" : "";
		let formInnards;
		if (this.props.config) {
			if (Object.keys(this.props.config).length !== 0) {
				formInnards = (
					<FormBuilderV2
						// this comment exists to prevent eslint from making this unreadable.
						type="create creative"
						data={this.props.config}
						configName="creativesConfig"
						onUpdate={this.updateState}
						state={this.state}
						auditLevelID={this.props.auditLevelID}
					/>
				);
			} else {
				formInnards = (
					<div>
						<TextInputSkeleton />
						<br />
						<TextInputSkeleton hideLabel />
					</div>
				);
			}
		}

		return (
			// <Modal
			// 	id={formEl}
			// 	className={`create--creative ${isDisabled}`}
			// 	// handleSubmit={handleSubmit}
			// 	passiveModal={false}
			// 	modalLabel="Add Creative"
			// 	modalHeading=""
			// 	open={this.state.open}
			// 	primaryButtonText="Submit"
			// 	secondaryButtonText="Create and Add Another"
			// 	onRequestSubmit={this.handleSubmit}
			// 	onSecondarySubmit={this.handleCreateAnother}
			// 	iconDescription="Close"
			// 	primaryButtonDisabled={this.state.loading}
			// 	onRequestClose={this.triggerOpenClose}
			// >
			// 	{this.state.loading && (
			// 		// <LoadingIcon className="loading_modal" />
			// 		<Loading />
			// 	)}
			// 	{this.state.isShow && <p className="showMessage">Previous Creative has been created successfully!</p>}
			// 	<form autoComplete="off">
			// 		<div className="form__group__container _m-t--10 _m-b--10">{formInnards}</div>
			// 		{this.state.showErrors && <div id="errors__container" />}
			// 	</form>
			// </Modal>
			<>
				<Modal
					id={formEl}
					className={`create--creative ${isDisabled}`}
					heading="Add Creative"
					description="Enter the information below, then click the Add button to create a new creative, or click on create and Add Another button to add another creative."
					isOpen={this.state.open}
					onRequestClose={() => {
						if (this.state.open) {
							this.triggerOpenClose();
						}
					}}
					size="medium"
					userClosable={true}
					onClick={() => {}}
					actionSetProps={{
						actionsLeft: (
							<Button className="first-button" display="secondary" onClick={this.triggerOpenClose} data-tracking-id-alt="cancel-add-creative">
								Cancel
							</Button>
						),
						actionsRight: (
							<>
								<Button
									className="second-button"
									display="secondary"
									disabled={!this.state.isFormDataValid}
									onClick={this.handleCreateAnother}
									data-tracking-id-alt="create-add-another-creative"
								>
									Create and Add Another
								</Button>
								<Button
									className="third-button"
									display="primary"
									disabled={!this.state.isFormDataValid}
									onClick={this.handleSubmit}
									data-tracking-id-alt="confirm-add-creative"
								>
									Add
								</Button>
							</>
						)
					}}
				>
					{this.state.isShow && <p className="showMessage">Previous Creative has been created successfully!</p>}
					{this.state.loading && <Loading className="modalLoading" />}
					<form autoComplete="off">
						<div className="form__group__container _m-t--10 _m-b--10">{formInnards}</div>
						{this.state.showErrors && <div id="errors__container" />}
					</form>
				</Modal>
			</>
		);
	}
}

export default CreateCreative;
